module.exports = __webpack_public_path__ + "img/wmdmb.ff7664f2.png";